import Constants from "../../Action/Constants";
import { ActionInterface } from "../../Interface/ActionInterface";

interface StateInterface {
  alertMessage: string;
  isFetching: boolean;
  fields: string[];
  translatedMessage: string;
  newVersionAvailable: boolean;
  errorId: any;
};

const initialState: StateInterface = {
  alertMessage: "",
  isFetching: false,
  fields: [],
  translatedMessage: "",
  newVersionAvailable: false,
  errorId: null
};

export const containerReducer = (state: StateInterface = initialState, action: ActionInterface): StateInterface => {

  switch (action.type) {
    /*
    |  Alert
    */

    case Constants.ALERT_SHOW:
      return {
        ...state,
        alertMessage: action.payload?.message
      };

    case Constants.ALERT_HIDE:
      return {
        ...state,
        alertMessage: ""
      };

    /*
    |  New Version
    */

    case Constants.NEW_VERSION_AVAILABLE:
      return {
        ...state,
        newVersionAvailable: true
      };

    case Constants.NEW_VERSION_IGNORE:
      return {
        ...state,
        newVersionAvailable: false
      };

    case Constants.PAGE_CONTACT_COMPANY_CREATE_FAILURE:
      return {...state,
        isFetching: false,
        fields: action.payload?.err.fields || [],
        translatedMessage: action.payload?.err.translatedMessage
      };  

    case Constants.PAGE_PROPERTY_CREATE_FAILURE:
      return {
        ...state,
        isFetching: false,
        fields: action.payload?.err.fields || [],
        translatedMessage: action.payload?.err.translatedMessage
      };

    case Constants.GLOBAL_CHARGE_CREATE_CREDIT_FAILURE:
    case Constants.GLOBAL_UNIT_CREATE_FAILURE:
      return {
        ...state,
        isFetching: false,
        fields: action.payload?.err && action.payload?.err.fields || [],
        translatedMessage: action.payload?.err && action.payload?.err.translatedMessage
      };  


    case Constants.PAGE_CONTACT_PERSON_CREATE_FAILURE:
      return {...state,
        isFetching: false,
        fields: action.payload?.err.fields || [],
        translatedMessage: action.payload?.err.translatedMessage,
        errorId: action.payload?.err.errorId
      };

    case Constants.GLOBAL_CONTRACT_CREATE_FAILURE:
      return {
        ...state,
        isFetching: false,
        fields: action.payload?.err.fields || [],
        translatedMessage: action.payload?.err.translatedMessage
      };

    case Constants.GLOBAL_CONTRACT_EXTEND_FAILURE:
      return {
        ...state,
        isFetching: false,
        fields: action.payload?.err.fields || [],
        translatedMessage: action.payload?.err.translatedMessage
      };

    case Constants.PAGE_CONTACT_COMPANY_UPDATE_FAILURE:
      return {...state,
        isFetching: false,
        fields: action.payload?.err.fields || [],
        translatedMessage: action.payload?.err.translatedMessage
      };

    case Constants.COACH_ERRORS_CLEAR:
      return {
        ...initialState
      };

    case Constants.AUTH_SIGNOUT:
      return {
        ...initialState
      };

    default:
      return state;
  }
};
